import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchVisitsByDateAndClientId } from '../store/actions/visitsActions';

export const useClientDataIfNeeded = (forceFetch = false) => {
  const dispatch = useDispatch();
  const { clientId } = useParams();
  const history = useHistory();
  const [alreadyFetched, setAlreadyFetched] = useState(false);
  const [fetching, setFetching] = useState(false);

  const { data, loadingStatus } = useSelector((state) => ({
    data: state.clientData.data[clientId],
    loadingStatus: state.clientData.loadingStatus[clientId],
  }));
  const { busy } = useSelector((state) => state.offline);

  useEffect(() => {
    if (busy) {
      return;
    }
    if (loadingStatus === 'fetched' || loadingStatus === 'not-fetched') {
      setFetching(false);
    }
    if (
      (loadingStatus !== 'fetching' &&
        loadingStatus !== 'fetched' &&
        loadingStatus !== 'not-fetched') ||
      (!fetching && forceFetch && !alreadyFetched)
    ) {
      setFetching(true);
      dispatch(fetchVisitsByDateAndClientId({ clientId }));
      setAlreadyFetched(true);
    }
  }, [
    alreadyFetched,
    clientId,
    dispatch,
    fetching,
    forceFetch,
    history,
    loadingStatus,
    busy,
  ]);

  return {
    data,
    loadingStatus,
  };
};
